import { render, staticRenderFns } from "./popWindow.vue?vue&type=template&id=38731fdf&scoped=true&"
import script from "./popWindow.vue?vue&type=script&lang=ts&"
export * from "./popWindow.vue?vue&type=script&lang=ts&"
import style0 from "./popWindow.vue?vue&type=style&index=0&id=38731fdf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38731fdf",
  null
  
)

export default component.exports